import { useEffect, useState } from "react";
import {
    FiCreditCard,

    FiSave,
    FiX,
    FiXCircle,
} from "react-icons/fi";

const initialState = {
    nombre: "",
    idTipoCuenta: "",
    idBanco: "",
    numeroReferencia: "",
    idMoneda: "",
    saldoInicial: "",
    saldoActual: "",
    color: "#2563eb",
    estado: "1",
};

export default function CuentaForm({
                                       initialData,
                                       onClose,
                                       onSave,
                                       tiposCuenta = [],
                                       bancos = [],
                                       monedas = [],
                                   }) {
    const [form, setForm] = useState(initialState);

    useEffect(() => {
        if (initialData) {
            setForm({
                ...initialState,
                ...initialData,
                idTipoCuenta:
                    initialData.idTipoCuenta ??
                    initialData.id_tipo_cuenta ??
                    "",
                idBanco:
                    initialData.idBanco ??
                    initialData.id_banco ??
                    "",
                idMoneda:
                    initialData.idMoneda ??
                    initialData.id_moneda ??
                    "",
            });
        } else {
            setForm(initialState);
        }
    }, [initialData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.nombre.trim()) {
            alert("El nombre de la cuenta es obligatorio");
            return;
        }

        if (!form.idTipoCuenta) {
            alert("Debe seleccionar un tipo de cuenta");
            return;
        }

        if (!form.idMoneda) {
            alert("Debe seleccionar una moneda");
            return;
        }

        await onSave({
            ...form,
            idTipoCuenta: Number(form.idTipoCuenta),
            idBanco: form.idBanco ? Number(form.idBanco) : null,
            idMoneda: Number(form.idMoneda),
            saldoInicial: Number(form.saldoInicial || 0),
            saldoActual: Number(form.saldoActual || form.saldoInicial || 0),
        });
    };

    return (
        <div className="modal-backdrop">
            <div className="modal-card">
                <div className="modal-header">
                    <h3 style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <FiCreditCard size={20} />
                        {initialData ? "Editar cuenta" : "Nueva cuenta"}
                    </h3>

                    <button className="btn-secondary" type="button" onClick={onClose}>
                        <FiX size={16} />
                    </button>
                </div>

                <form className="grid-form" onSubmit={handleSubmit}>
                    <div>
                        <label>Nombre de la cuenta</label>
                        <input
                            name="nombre"
                            placeholder="Ej. BCP principal, Yape, Caja chica"
                            value={form.nombre}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Tipo de cuenta</label>
                        <select
                            name="idTipoCuenta"
                            value={form.idTipoCuenta}
                            onChange={handleChange}
                        >
                            <option value="">Seleccione tipo de cuenta</option>
                            {tiposCuenta.map((item) => (
                                <option key={item.id_tipo_cuenta} value={item.id_tipo_cuenta}>
                                    {item.nombre}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label>Banco</label>
                        <select
                            name="idBanco"
                            value={form.idBanco}
                            onChange={handleChange}
                        >
                            <option value="">Seleccione banco</option>
                            {bancos.map((item) => (
                                <option key={item.id_banco} value={item.id_banco}>
                                    {item.nombre}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label>Número o referencia</label>
                        <input
                            name="numeroReferencia"
                            placeholder="Ej. 1234, alias, referencia"
                            value={form.numeroReferencia}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Moneda</label>
                        <select
                            name="idMoneda"
                            value={form.idMoneda}
                            onChange={handleChange}
                        >
                            <option value="">Seleccione moneda</option>
                            {monedas.map((item) => (
                                <option key={item.id_moneda} value={item.id_moneda}>
                                    {item.codigo} - {item.nombre}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label>Saldo inicial</label>
                        <input
                            name="saldoInicial"
                            type="number"
                            step="0.01"
                            placeholder="0.00"
                            value={form.saldoInicial}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Saldo actual</label>
                        <input
                            name="saldoActual"
                            type="number"
                            step="0.01"
                            placeholder="0.00"
                            value={form.saldoActual}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Color identificador</label>
                        <input
                            name="color"
                            type="color"
                            value={form.color}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-actions full-width">
                        <button className="btn-secondary" type="button" onClick={onClose}>
                            <FiXCircle size={16} />
                            Cancelar
                        </button>

                        <button className="btn-primary" type="submit">
                            <FiSave size={16} />
                            Guardar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}